import { render, staticRenderFns } from "./ProductQueryAssist.vue?vue&type=template&id=1353a21f"
import script from "./ProductQueryAssist.vue?vue&type=script&lang=js"
export * from "./ProductQueryAssist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports